<template>
  <div class="content" style="background-color: #bae3f8">
    <div class="tv">
      <el-button class="button1" @click="showButtons"></el-button>
      <el-button class="button2" @click="openNew"></el-button>
      <el-button class="button3" @click="meetShow"></el-button>
      <el-button class="button4" @click="onClose"></el-button>
      <div v-show="buttonsView" class="buttonsView">
        <el-button class="buttons button_1" @click="buttonsClick('flag1')"></el-button>
        <el-button class="buttons button_2" @click="buttonsClick('flag2')"></el-button>
        <el-button class="buttons button_3" @click="buttonsClick('flag3')"></el-button>
        <el-button class="buttons button_4" @click="buttonsClick('flag4')"></el-button>
      </div>
    </div>
    <el-dialog :fullscreen="true" :visible.sync="outerVisible">
      <img style="width: 100%;height: 100%" src="../static/img/home.png" alt="">
    </el-dialog>

    <el-dialog :visible.sync="meetView" width="40%">
      <img style="width: 100%;height: 100%" src="../static/img/tv/meet.jpg" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'tvView',
    components: {},
    data: function () {
      return {
        meetView: false,
        outerVisible: true,
        buttonsView: false,
        user: {
          phoneNum: null,
          code: null,
          name: null
        }
      }
    },
    computed: {
      ...mapGetters([
        'phone',
        'name'
      ])
    },
    mounted() {
      debugger
      setTimeout(() => {
        this.outerVisible = false
      }, 3000)
    },
    methods: {
      ...mapActions([
        'savePhone',
        'saveName',
        'saveToken'
      ]),

      openNew(){
        let {href} = this.$router.resolve({path:'/sh'});
        window.open(href, '_blank');
      },
      meetShow(){
        this.meetView = true
      },
      showButtons() {
        this.buttonsView = !this.buttonsView
      },
      buttonsClick(val) {
        let view = {flag1: '训练一', flag2: '训练二', flag3: '训练三', flag4: '训练四'}
        let payload = {uuid: 'aaaa', action: 'runTrain', data: [`${view[val]},描点,初级,0`, true]}
        window.tvView.contentWindow.postMessage(payload, '*')
        this.$router.push({path: '/dlView', query: {flag: val}})

      },
      onClose() {
        window.localStorage.removeItem('user')
        this.$router.push({path: '/home'})
        // if (navigator.userAgent.indexOf("Firefox") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1) {
        //   window.location.href = "about:blank";
        //   window.close();
        // } else {
        //   window.opener = null;
        //   window.open("", "_self");
        //   window.close();
        // }
      }
    }
  }
</script>

<style scoped lang="less">
  .tv {
    width: 1024px;
    height: 768px;
    background-image: url("../static/img/tv/tv.png");
  }

  .el-button {
    margin: 0;
    border: 0
  }

  .button1 {
    position: relative;
    top: 300px;
    left: 260px;
    width: 190px;
    height: 190px;
    background-color: transparent;
  }

  .button2 {
    position: relative;
    top: 300px;
    left: 340px;
    width: 105px;
    height: 100px;
    background-color: transparent;
  }

  .button3 {
    position: relative;
    top: 225px;
    left: 358px;
    width: 150px;
    height: 150px;
    background-color: transparent;
  }

  .button4 {
    position: relative;
    top: 370px;
    left: 245px;
    width: 100px;
    height: 90px;
    background-color: transparent;
  }

  .buttonsView {
    position: relative;
    top: 333px;
    left: 305px;
    width: 318px;
    height: 58px;
    background-color: transparent;
    background-image: url("../static/img/tv/select.png");
  }

  .buttons {
    background-color: transparent;
    width: 60px;
    height: 55px;
  }

  .button_1 {
    margin-left: 5px;
    margin-right: 20px;
  }

  .button_2 {
    margin-right: 25px;
  }

  .button_3 {
    margin-right: 20px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: 100%;
  }
</style>
